import { fetchCityConstant } from 'src/services/api';


const cityType = [
  {
    type: 0,
    value: [],
  },
  {
    type: 1,
    value: [],
  },
  {
    type: 2,
    value: [],
  },
  {
    type: 3,
    value: [],
  },
  {
    type: 4,
    value: [],
  },
];


fetchCityConstant().then((res) => {
  if (!res) {
    return;
  }


  const { quickSelectCity } = res || {};


  cityType[0].value = quickSelectCity.super;
  cityType[1].value = quickSelectCity.first;
  cityType[2].value = quickSelectCity.second;
  cityType[3].value = quickSelectCity.third;
  cityType[4].value = quickSelectCity.other;
});


export {
  cityType,
};